import { UsageUserServiceModule } from '@common-services/sdk';
import { ResourceInfo } from '../models/IConfig';
import { BaseService } from './BaseService';
import { IPublicClientApplication } from '@azure/msal-browser';

const USAGEUSERID: string = 'UsageUserId';

export interface UsageUserIdWithLogs {
  usageUserId: string;
  errorLog: string;
}

export class UsageUserService extends BaseService {
  private readonly usageUserClient: UsageUserServiceModule.UsageUserClient;
  public constructor(resourceInfo: ResourceInfo, msalInstance: IPublicClientApplication) {
    super(resourceInfo, msalInstance);
    //TODO: Need to figure out a way not to have .bind in each service.
    const getAccessToken = this.getAccessToken.bind(this);
    this.usageUserClient = new UsageUserServiceModule.UsageUserClient(
      { getAuthorization: getAccessToken },
      resourceInfo.resourceBaseUrl
    );
  }

  private async getUsageUserIdFromApi(): Promise<UsageUserIdWithLogs> {
    try {
      const usageUser = await this.usageUserClient.getMyUsageUserId();
      return {
        usageUserId: usageUser,
        errorLog: '',
      };
    } catch (e) {
      return {
        usageUserId: '',
        errorLog: `Exception while fetching UsageUserId from API ${e}\n`,
      };
    }
  }
  /**
   * Get AnonymizedId for User.
   */
  public async getAnonymizedUserId(): Promise<UsageUserIdWithLogs> {
    var anonymousId = '';
    var idFromStorage;
    var errorLog = '';
    try {
      idFromStorage = localStorage.getItem(USAGEUSERID);
    } catch (e) {
      errorLog += `Exception while fetching UsageUserId from local storage ${e}\n`;
    }

    if (idFromStorage && idFromStorage != '') {
      anonymousId = idFromStorage;
    } else {
      var apiResponse = await this.getUsageUserIdFromApi();
      anonymousId = apiResponse.usageUserId;
      errorLog += apiResponse.errorLog;
    }

    if (anonymousId && anonymousId != '' && anonymousId != idFromStorage) {
      try {
        localStorage.setItem(USAGEUSERID, anonymousId);
      } catch (e) {
        errorLog += `Exception while setting UsageUserId in local storage ${e}\n`;
      }
    }

    return { usageUserId: anonymousId, errorLog };
  }
}
